import React from 'react';

// PuzzlePreviewScreen Component: Displays details about the selected puzzle before the game starts
const PuzzlePreviewScreen = ({ selectedPuzzle, setCurrentScreen }) => {
  // If no puzzle is selected, redirect back to the selection screen
  if (!selectedPuzzle) {
    setCurrentScreen('selectPuzzle');
    return null;
  }

  return (
    <div className="flex flex-col items-center justify-center h-full p-4 text-center">
      <div className="bg-white p-8 rounded-xl shadow-2xl max-w-lg w-full border-4 border-pink-500">
        <h2 className="text-3xl font-extrabold mb-4 text-orange-600">Puzzle Preview</h2>
        <p className="text-gray-700 text-xl mb-6">You have picked:</p>
        <img
          src={selectedPuzzle.imageUrl}
          alt={selectedPuzzle.name}
          className="w-64 h-64 sm:w-48 sm:h-48 rounded-full object-cover mx-auto mb-6 border-4 border-pink-400 shadow-lg"
        />
        <h3 className="text-4xl font-bold text-pink-600 mb-4">{selectedPuzzle.name}</h3>
        <p className="text-gray-700 text-lg mb-8 italic">{selectedPuzzle.personalityDetails}</p>
        
        <button
          onClick={() => setCurrentScreen('selectDifficulty')} // ✅ Go to difficulty screen instead of game
          className="w-full bg-gradient-to-r from-pink-500 to-orange-500 text-white font-bold py-4 px-8 rounded-lg shadow-lg hover:from-pink-600 hover:to-orange-600 transition duration-300 transform hover:scale-105 text-2xl"
        >
          Play Now!
        </button>

        <button
          onClick={() => setCurrentScreen('selectPuzzle')} // Back to puzzle selection
          className="mt-4 w-full bg-gray-300 text-gray-800 font-bold py-3 px-6 rounded-lg shadow-md hover:bg-gray-400 transition duration-300 text-xl"
        >
          Choose Another Puzzle
        </button>
      </div>
    </div>
  );
};

export default PuzzlePreviewScreen;
